import $ from 'jquery';
import debounce from 'cmnjs/function/debounce';
import config from './config';

// Maksymalna szerokość listy z linkami nawigacyjnymi (bez "Więcej"), w px
const maxMenuWidth = 300;

let tabletResolution;
let openedModalIndicator = false;

let $navList;
let $listElems;
let $showMoreLink;
let $showMoreContainer;
let $navModalBox;
let $navModalClose;
let $hiddenLinks;

function calculateListWidth() {
  return $navList.outerWidth(true);
}

function toggleListElems() {
  $listElems = $navList.find('li:not(.menu__navigation-list-item--show-more)');

  $listElems.show();
  $showMoreContainer.hide();

  if (!tabletResolution) {
    return;
  }

  $listElems.each(() => {
    if (calculateListWidth() > maxMenuWidth) {
      $navList.find('li:not(.menu__navigation-list-item--show-more):visible:last').hide();
    }
  });

  $showMoreContainer.css('display', 'inline-block');
}

function modalBoxEvents() {
  $showMoreLink.on('click', e => {
    e.preventDefault();

    if (!openedModalIndicator) {
      $hiddenLinks = $navList.find('li:hidden').clone();

      $hiddenLinks.css('display', 'block');

      $navModalBox.find('.menu__navigation-list').append($hiddenLinks);

      openedModalIndicator = true;
    }

    $navModalBox.toggle();
  });

  $navModalClose.on('click', () => {
    $navModalBox.toggle();
  });
}

function init() {
  $navList = $('.js-nav-list');
  $showMoreLink = $navList.find('.js-nav-show-more');
  $showMoreContainer = $navList.find('.menu__navigation-list-item--show-more');
  $navModalBox = $navList.find('.js-nav-modal-box');
  $navModalClose = $navModalBox.find('.js-nav-modal-close');

  config.$el.window.on('scroll touchmove', debounce(() => {
    if ($navModalBox.is(':not(:hidden)')) {
      $navModalBox.hide();
    }
  }, 200));

  modalBoxEvents();
}

function resize() {
  tabletResolution = window.matchMedia('(min-width: 890px)').matches
    && window.matchMedia('(max-width: 1024px)').matches;

  $navModalBox.hide();

  toggleListElems();
}

export default {
  init,
  resize,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/topNavigation.js